/* eslint-disable react/display-name */
import { forwardRef } from "react"

import { Tappable } from "@trueskin-web/components"

import RecommendedLabel from "../../../components/choose-plan/core/plans/recommended-label"

const PlanCard = forwardRef(
  (
    { isSelected, plan, isRecommended, onClick, children, className, ...props },
    ref = null
  ) => {
    const { title, isSubscription } = plan

    const dataTestIdPrefix = isSubscription
      ? "auto-refill"
      : title.toLowerCase()

    return (
      <Tappable
        ref={ref}
        data-testid={`web-portal-plan-selection-${dataTestIdPrefix}-plan-block`}
        data-component-name="Plan"
        sx={{
          position: "relative",
          p: isSelected ? "15px" : 4,
          background: "white",
          borderRadius: "8px",
          border: isSelected ? "2px solid" : "1px solid",
          borderColor: isSelected
            ? "primary"
            : isSubscription
            ? "#E1E1E1"
            : "white",
          transition: "border 0.2s ease-in",
        }}
        className={className}
        onClick={onClick}
        {...props}
      >
        {children}

        {isRecommended ? (
          <div
            data-testid="web-portal-plan-selection-plan-block-voucher"
            sx={{
              position: "absolute",
              top: 0,
              right: 4,
              transform: "translateY(-50%)",
              "& > div": {
                background: "#3244FF",
              },
            }}
          >
            <RecommendedLabel />
          </div>
        ) : null}
      </Tappable>
    )
  }
)

export default PlanCard
